import { AsyncPipe } from '@angular/common';
import {
  Component,
  ChangeDetectionStrategy,
  ViewChild,
  Input,
  ElementRef,
  Renderer2,
  EventEmitter,
  Output,
  ViewEncapsulation,
  HostBinding,
  inject,
} from '@angular/core';

import { CaptureModel } from '@modules/media/models/capture.model';
import { PlayerService } from '@modules/media/service/player.service';

import { DynamicContainerComponent } from '../../../ui/dynamic-container/dynamic-container.component';
import { VideoControlsComponent } from '../video-controls/video-controls.component';
import { VideoDefaultsComponent } from '../video-defaults';

@Component({
  selector: 'mb-inline-player',
  templateUrl: './inline-player.component.html',
  styleUrls: ['./inline-player.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DynamicContainerComponent, VideoControlsComponent, AsyncPipe],
})
export class InlinePlayerComponent extends VideoDefaultsComponent {
  elRef: ElementRef;
  playerService: PlayerService;
  renderer: Renderer2;

  @HostBinding('class.hover-video')
  @Input()
  hoverVideo = false;
  @Input() muted = false;

  @ViewChild('videoParent', { static: false }) videoParent!: ElementRef;
  @Input() controls = true;
  @Input() allowPictureInPicture = true;
  @Output() capture = new EventEmitter<CaptureModel>();
  constructor() {
    const elRef = inject(ElementRef);
    const playerService = inject(PlayerService);
    const renderer = inject(Renderer2);

    super();

    this.elRef = elRef;
    this.playerService = playerService;
    this.renderer = renderer;
  }

  hoverPlayer() {
    if (this.hoverVideo && this.player) {
      this.player.play();
    }
  }

  stopHoverplay() {
    if (this.hoverVideo && this.player) {
      this.player.stop();
    }
  }

  togglePlay() {
    if (!this.player) return;

    this.player.togglePlay();
  }
}
